import { createSearchParams } from 'react-router-dom';
import { getFormattedSourceSearchParams } from './getFormattedSourceSearchParams';
import { getPageFromUrl, getSearchParamsByGridCode } from './getSearchParamsByGridCode';
import { SOURCE_DATA_GRID } from './getSourceSearchParams';
export const setSourceSearchParamsByGridCode = (gridCode: string, rowIndex: string, useSourceSearchParams = false): string => {
  const searchParamsByGridCode2 = useSourceSearchParams ? getFormattedSourceSearchParams() : getSearchParamsByGridCode(gridCode);
  const params = createSearchParams({
    [SOURCE_DATA_GRID]: [`${gridCode},${searchParamsByGridCode2?.queryId},${rowIndex}`]
  });
  const currentPage = getPageFromUrl(gridCode);
  if (currentPage !== undefined) {
    params.set('sourcePage', String(currentPage));
  }
  return params.toString();
};